<template lang="pug">
vm-row( class="details" vm-w="12")
  vm-col(class="details__titles" vm-type="flex" vm-align="center" vm-w=12)
    vm-table(multiple v-model="selected" max-items="15" pagination max-height="350px" :data="form.details" )
      template(slot="header")
        div( class="details__header" vm-w="6")
          h4 {{ $t('requisitions_mailboxes.filter') }}
          vm-input(class="details__search" ref="search" icon="search" v-model="searchParam" @keyup.enter="onSearch" width="80%")
        div( class="details__header" vm-w="6")
          .total-products() Total de productos: {{ toReceive.length }}
      template(slot="thead")
        vm-th(:key="index" v-for="(column, index) in columns") {{ $t('purchase_orders.' + column) }}
      template(slot-scope="{data}")
        vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
          vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
            slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
            slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
            slot(v-if="column == 'supply'")  {{ data[indextr][column]['sku'] }}
            slot(v-if="column == 'supply_pending_quantity'")  {{ data[indextr][column] }}
            slot(v-if="column == 'received'")  {{ data[indextr][column] }}
            vm-input(@input="onCheckValue(data[indextr])" :disabled="data[indextr].for_recieving === 0" v-if="column == 'for_recieving'" v-model="data[indextr].for_recieving" )
            slot(v-if="column != 'status' && column != 'supply_pending_quantity' && column != 'for_recieving' && column != 'received' && column != 'supply' && column != 'created_at' && column != 'name' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
  vm-col(class="details__buttons" vm-type="flex" vm-align="center" vm-w=12)
    vm-button(:disabled="!hasReceptions" @click="OnReceive()" icon="arrow-downward-outline") {{ $t('purchase_orders.to_receive')  }}
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('WarehouseReceptions')

export default {
  name: 'DetailsReceptions',
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['id', 'supply', 'supply_unit', 'supply_pending_quantity', 'received', 'for_recieving'],
    form: {
      details: []
    },
    purchase: {},
    searchParam: '',
    toReceive: {}
  }),
  computed: {
    ...mapGetters([
      'purchaseOrders'
    ]),
    hasReceptions () {
      return this.toReceive.length && this.form.status !== 'pending'
    }
  },
  watch: {
    'purchaseOrders' (data) {
      this.form = data.length ? data[0] : {
        details: [],
        ...data
      }
      this.purchase = { ...this.form }
      this.selected = []
    },
    selected () {
      const data = this.selected.filter((detail) => Number(detail.supply_pending_quantity) !== Number(detail.received))
      this.toReceive = [...data]
    }
  },
  methods: {
    OnReceive () {
      this.$emit('onConfirm', { detail: this.toReceive, purchase: this.form })
    },
    onCheckValue (data) {
      setTimeout(() => {
        if (data.for_recieving <= 0 || data.for_recieving > (data.supply_pending_quantity - data.received)) {
          data.for_recieving = 1
          return data.for_recieving
        }
        return data.for_recieving
      }, 500)
    },
    onSearch () {
      this.searchParam ? this.form.details = Array(...this.purchase.details.filter(detail => detail.supply.sku.toLowerCase().includes(this.searchParam.toLowerCase()))) : this.form = { ...this.purchase }
    }
  }
}
</script>
<style lang="scss" scoped>
  .details {
    &__buttons {
      flex-direction: row-reverse;
      margin: 20px;
      .vm-button {
        flex-direction: row-reverse;
        width: 188px;
        border-radius: 20px;
        justify-content: space-between;
      }
    }
  }
  header {
    span {
      display: flex;
      justify-content: space-between;
    }
  }
</style>
